import { css } from "@emotion/css";
import { ExternalLink } from "@octopusdeploy/design-system-components";
import { space, text } from "@octopusdeploy/design-system-tokens";
import ArgoCDInstancesHelpImage from "~/components/ContextualHelpLayout/PageHelpRegistry/Registrations/Areas/Infrastructure/components/ArgoCDInstancesHelpImage.svg";
import { LearnMoreResources, OverviewContainer, OverviewHighlightText, TopicsContainer } from "~/components/ContextualHelpLayout/PageHelpRegistry/Registrations/CommonComponents/CommonViews";
import ImageWithPlaceholder from "~/components/GettingStarted/ImageWithPlaceholder/ImageWithPlaceholder";
const styles = {
    imgContainer: css({
        marginTop: space[16],
        marginBottom: space[16],
    }),
    fixImgWidth: css({
        "&&": {
            width: "100% !important",
        },
    }),
    rulesList: css({
        margin: 0,
        paddingLeft: space[16],
        listStyleType: "decimal",
        font: text.body.regular.medium,
        li: {
            paddingBottom: space[8],
            "&:lastChild": {
                paddingBottom: 0,
            },
        },
    }),
};
export const ArgoCDInstancesOverview = () => (<OverviewContainer>
        <OverviewHighlightText>
            <p>
                <ExternalLink href={"argo-cd-instances-docs"}>Argo CD instances</ExternalLink> let you combine your GitOps workflows with powerful deployment orchestration from Octopus.
            </p>
            <div className={styles.imgContainer}>
                <ImageWithPlaceholder src={ArgoCDInstancesHelpImage} alt={"Argo CD in Octopus"} className={styles.fixImgWidth}/>
            </div>
            <p>Here’s an overview of how to get started with Argo CD in Octopus:</p>
            <br />
            <ol className={styles.rulesList}>
                <li>Install a gateway in your cluster.</li>
                <li>Create a new Octopus project.</li>
                <li>Add an Argo CD step to update container images or generate manifests from templates.</li>
                <li>Add annotations to your Argo CD applications to map them to Octopus projects, environments and tenants.</li>
                <li>Provide Git credentials for each source.</li>
                <li>Configure the remaining step settings.</li>
                <li>Deploy with Octopus and Argo CD.</li>
            </ol>
        </OverviewHighlightText>
    </OverviewContainer>);
export const ArgoCDInstancesTopics = () => (<TopicsContainer>
        <LearnMoreResources>
            <div>
                <ExternalLink href={"argo-cd-integration-docs"}>Argo CD in Octopus</ExternalLink>
            </div>
            <div>
                <ExternalLink href={"argo-cd-getting-started"}>Getting started</ExternalLink>
            </div>
            <div>
                <ExternalLink href={"argo-cd-steps-docs"}>Deployment steps</ExternalLink>
            </div>
            <div>
                <ExternalLink href={"argo-cd-annotations-docs"}>Annotations</ExternalLink>
            </div>
            <div>
                <ExternalLink href={"argo-cd-supported-use-cases"}>Supported use cases</ExternalLink>
            </div>
        </LearnMoreResources>
    </TopicsContainer>);
